import React from 'react';
import { NewsCategoryId, newsCategories } from './constants';

interface NewsCategoriesProps {
  selectedCategory: NewsCategoryId;
  onCategoryChange: (category: NewsCategoryId) => void;
}

const NewsCategories: React.FC<NewsCategoriesProps> = ({
  selectedCategory = 'all',
  onCategoryChange
}) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-10">
      {newsCategories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`
            px-5 py-2 rounded-full text-sm font-medium transition-all duration-300
            ${selectedCategory === category.id
              ? 'bg-[#1B2A4A] text-white'
              : 'bg-white hover:bg-[#FAFAF8] text-[#5A6577] hover:text-[#2D3748]'
            }
            border ${selectedCategory === category.id
              ? 'border-transparent'
              : 'border-[#E8E6E1]'
            }
          `}
        >
          {category.label}
        </button>
      ))}
    </div>
  );
};

export default NewsCategories;
